import i18n from "../../../AppSystem/i18n";
import { ChangeDateFormat } from "../../../Common/Helpers/ChangeDateFormat";
import {ToCustomDecimal} from "../../../AppSystem/Helpers/ToCustomDecimal";

class ResponseSwedbankReport {
    constructor({
                    id = '',
                    visualId = '',
                    accountingNumber = '',
                    amountPaidOut = 0,
                    amount = 0,
                    reportingDate = '',
                    totalTransactions = '',
                    merchantId = '',
                    
                } = {}) {
        this.id = id;
        this.visualId = visualId;
        this.accountingNumber = accountingNumber;
        this.amountPaidOut = amountPaidOut;
        this.amount = amount;
        this.reportingDate = reportingDate;
        this.totalTransactions = totalTransactions;
        this.merchantId = merchantId;
    }

    static getAttributes(filter = null, validationSchema = null, optionsData = null, customField = null) {


        const attributes =  {
            id :{
                'label': 'Id',
                'sortable': true,
                'sortField': "id",
                'value': (item) => item.id || "",
            },
            visualId :{
                'label': i18n.t('modelLabel.id'),
                'sortable': true,
                'sortField': 'visualId',
                'value': (item) => item.visualId || "",
            },
            accountingNumber :{
                'label': i18n.t('swedbankReport.redovisningsnummer'),
                'sortable': true,
                "sortField":'accountingNumber',
                'value': (item) => item.accountingNumber || "",
            },
            amountPaidOut: {
                'label': i18n.t('swedbankReport.utbetaltBelopp'),
                'sortable': true,
                "sortField":'amountPaidOut',
                "thClass": "ps-5",
                'insideClass' : (item)=> item.amountPaidOut >= 0 ? 'text-green text-end fixed-width' : 'text-red text-end fixed-width',
                "value": (item) => item.amountPaidOut ? ToCustomDecimal(item.amountPaidOut) +' kr' : "",
                'type': 'number' 
            },
            amount: {
                'label': i18n.t('reimbursement.amount'),
                'sortable': true,
                "sortField":'amount',
                "thClass": "ps-5",
                'insideClass' : (item)=> item.amount >= 0 ? 'text-green text-end fixed-width' : 'text-red text-end fixed-width',
                "value": (item) => item.amount ? ToCustomDecimal(item.amount) +' kr' : "",
                'type': 'number' 
            },
            reportingDate: {
                'label': i18n.t('swedbankReport.redovisningsdatum'),
                'sortable': true,
                "sortField":'reportingDate',
                'value': (item) => item.reportingDate ? ChangeDateFormat('date', item.reportingDate) : ''|| "",
                'type': 'dateTime'
            }
        };

        return attributes;
    }
}

export default ResponseSwedbankReport;